import { useState } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSnackbar } from '~/containers/Snackbar/SnackbarContext';
import messages from './messages';
import { useDeleteRecurrentApplication } from '~/hooks/api/useDeleteRecurrentApplication';

type AvailabilityDeleteProps = {
  publisherId: number;
  recurrentApplicationId: number;
  shiftsReleasedUntil: Date;
};

const AvailabilityDelete = (props: AvailabilityDeleteProps) => {
  const intl = useIntl();
  const { showSnackbar } = useSnackbar();
  const [isDialogVisible, setDialogVisibility] = useState(false);
  const handleClose = () => setDialogVisibility(false);
  const handleOpen = () => setDialogVisibility(true);
  const deleteAvailabilityMutation = useDeleteRecurrentApplication(
    props.publisherId
  );
  const handleDelete = async () => {
    try {
      await deleteAvailabilityMutation.mutateAsync(
        props.recurrentApplicationId
      );
    } catch (_error) {
      showSnackbar({
        message: intl.formatMessage(messages.deletingAvailabilityFailed),
      });
      handleClose();
      return;
    }
    showSnackbar({
      message: intl.formatMessage(messages.deletingAvailabilitySucceeded),
    });
    handleClose();
  };
  return (
    <>
      <IconButton
        edge="end"
        onClick={handleOpen}
        aria-label={intl.formatMessage(messages.buttonLabel)}
        size="large"
      >
        <DeleteIcon />
      </IconButton>
      {isDialogVisible ? (
        <Dialog
          open={isDialogVisible}
          onClose={handleClose}
          aria-labelledby="delete-availability-dialog-title"
          aria-describedby="delete-availability-dialog-description"
        >
          <DialogTitle id="delete-availability-dialog-title">
            <FormattedMessage {...messages.deleteAvailabilityTitle} />
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="delete-availability-dialog-description">
              <FormattedMessage {...messages.deleteAvailabilityText} />
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleClose}
              color="primary"
              disabled={deleteAvailabilityMutation.isPending}
            >
              <FormattedMessage {...messages.deleteAvailabilityCancel} />
            </Button>
            <Button
              onClick={handleDelete}
              color="primary"
              disabled={deleteAvailabilityMutation.isPending}
            >
              <FormattedMessage {...messages.deleteAvailabilityConfirm} />
            </Button>
          </DialogActions>
        </Dialog>
      ) : null}
    </>
  );
};

export default AvailabilityDelete;
